import { render } from "./PosPurchase.vue?vue&type=template&id=a00db890&scoped=true&ts=true"
import script from "./PosPurchase.vue?vue&type=script&lang=ts"
export * from "./PosPurchase.vue?vue&type=script&lang=ts"

import "./PosPurchase.vue?vue&type=style&index=0&id=a00db890&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a00db890"]])

export default __exports__